/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentRiskClasses.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Risk Class API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Monday, January 21, 2019 - 04:45:03 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      01/21/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const RiskClasses = {
    all: () => requests.get('/RiskClasses'),
    get: riskclassid => requests.get(`/RiskClass/${riskclassid}`),
    create: riskclass => requests.post(`/RiskClasses`, riskclass),
    update: (riskclassid, riskclass) => requests.put(`/RiskClass/${riskclassid}`, riskclass),
    delete: riskclassid => requests.del(`/RiskClass/${riskclassid}`),
};


// WEBPACK FOOTER //
// ./src/agents/agentRiskClasses.js